import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"
import ListOfProductCarouselConfig from "@widgets/ListOfProductsCarousel/ListOfProductCarousel.skeleton.js"
import ListOfItemsConfig from "@widgets/ListOfItemsOnCart/ListOfItemsOnCart.skeleton"
import FootNotesConfig from "@widgets/Footnotes/Footnotes.skeleton"
import CarePlanUpsellConfig from "@widgets/CarePlanUpsell/CarePlanUpsell.skeleton"
import ApplyCouponConfig from "@widgets/ApplyCoupon/ApplyCoupon.skeleton"
import LabTestUpsellConfig from "@widgets/LabTestUpsell/LabTestUpsell.skeleton"
import BillSumaryConfig from "@widgets/BillSummaryWidget/BillSummaryWidget.skeleton"
import TCPPointsConfig from "@widgets/TCPPoints/TCPPoints.skeleton"
import AddressSelectionCollapsed from "@widgets/AddressSelectionCollapsed/AddressSelectionCollapsed.skeleton"

const ButtonConfig = [{ span: 8, height: "40px", classes: "marginTop-56" }]
const VerticalDivider = [{ span: 2 }]

function CartSkeleton() {
    return (
        <div className="page-container">
            <div className="container-fluid flex">
                <div className="flex-column">
                    <Skeleton config={ListOfItemsConfig} isComponent></Skeleton>
                    <Skeleton config={ListOfProductCarouselConfig} isComponent></Skeleton>
                    <Skeleton config={FootNotesConfig} isComponent></Skeleton>
                </div>
                <div className="flex-column">
                    <Skeleton config={VerticalDivider} isComponent></Skeleton>
                </div>
                <div className="flex-column">
                    <Skeleton config={CarePlanUpsellConfig} isComponent></Skeleton>
                    <Skeleton config={ApplyCouponConfig} isComponent></Skeleton>
                    <Skeleton config={LabTestUpsellConfig} isComponent></Skeleton>
                    <Skeleton config={BillSumaryConfig} isComponent></Skeleton>
                    <Skeleton config={TCPPointsConfig} isComponent></Skeleton>
                    <Skeleton config={AddressSelectionCollapsed} isComponent></Skeleton>
                    <Skeleton config={ButtonConfig} isComponent></Skeleton>
                </div>
            </div>
        </div>
    )
}

export default CartSkeleton
